import { render, staticRenderFns } from "./statisticsdetail.vue?vue&type=template&id=b3e80e40&scoped=true"
import script from "./statisticsdetail.vue?vue&type=script&lang=js"
export * from "./statisticsdetail.vue?vue&type=script&lang=js"
import style0 from "./statisticsdetail.vue?vue&type=style&index=0&id=b3e80e40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e80e40",
  null
  
)

export default component.exports